import {Controller} from 'stimulus';

export default class extends Controller {
  connect() {
    const showCookieBar = document.cookie.indexOf('cw_to_ld_modal_viewed=true') === -1;
    if (showCookieBar) {
      this.element.classList.add('show');
      document.cookie = 'cw_to_ld_modal_viewed=true; ' +
                        'path=/ ;expires=Fri, 31 Dec 9999 23:59:59 GMT';

      $(window).on('click', () => {
        this.element.classList.remove('show');
      });

      $(this.element).find('button.close').on('click', () => {
        this.element.classList.remove('show');
      });

      $(this.element).on('click', (event) => {
        event.stopPropagation();
      });
    }
  }
}
